module.exports = __webpack_public_path__ + "img/play_5.c0f5487e.png";